let apiHost = process.env.SANIQ_API;
let appApiHost = process.env.SANIQ_APP_API;
const baseHost = process.env.SANIQ_BASE_HOST;
const httpSchemaApi = process.env.HTTP_SCHEMA_API;
const httpSchemaAppApi = process.env.HTTP_SCHEMA_APP_API;
const websocketSchema = process.env.WEBSOCKET_SCHEMA;
let [tenant] = window.location.host.split('.');

if (process.env.REACT_WEBPACK_ENV === 'internal') {
  const host = tenant.split("-");
  const specialTenants = ["login", "manage", "meeting"];
  const urlTenant = specialTenants.includes(host[0]) ? host[1] : host[0];
  apiHost = `${urlTenant}-${apiHost}`;
  appApiHost = `${urlTenant}-${appApiHost}`;
  [tenant] = tenant.split("-");
}

const config = Object.freeze({
  apiHost: apiHost,
  apiUrl: `${httpSchemaApi}://${apiHost}`,
  appApiUrl: `${httpSchemaAppApi}://${appApiHost}/srm/api`,
  appEnv: process.env.REACT_WEBPACK_ENV,
  baseUrlWithoutSubdomain: baseHost,
  qurasoftApiBaseUrl: 'https://api.qurasoft.de',
  qurasoftApiUrl: 'https://api.qurasoft.de/api',
  // eslint-disable-next-line @stylistic/max-len
  qurasoftApiKey: 'c24a2789cbb683b18e7c5ba48e4606459b64a5a5f6dc5dd94ad2cf83dca6643e5d2579597d7fdb57dd51abf5e9a01cfef0de8fe9996a852a3715ea23c312788cb9d1067b5f5fea931faf24f5ef51216b231fcd2d788493c497f0e809299f459e48a16c851de84f9085fc3c5e3f20cb66842ac0945f51c1aae98dd63baa0d38f9',
  tenant,
  webSocketUrl: `${websocketSchema}://${apiHost}/cable`
});

export default config;
